import { BASE_URL_LEGACY } from "./";
import moment from "moment";

export const activityDetailService = {
  getDetail,
};

function getDetail(
  dependant_user_id,
  activity_id,
  start_timestamp,
  end_timestamp
) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  console.log("start raw", start_timestamp);
  console.log("end raw", end_timestamp);

  console.log(
    "start other",
    moment.unix(1649105998).format("DD MM YYYY - hh:mm")
  );
  console.log(
    "end other",
    moment.unix(1649086450).format("DD MM YYYY - hh:mm")
  );

  console.log(
    "start",
    moment.unix(start_timestamp).format("DD MM YYYY - hh:mm")
  );
  console.log("end", moment.unix(end_timestamp).format("DD MM YYYY - hh:mm"));
  console.log(
    "is end before start?!",
    moment.unix(end_timestamp).isBefore(moment.unix(start_timestamp))
  );

  return fetch(
    `${BASE_URL_LEGACY}/assisted_living/activities/${activity_id}/?dependant_user_id=${dependant_user_id}&activity_id=${activity_id}&start_timestamp=${start_timestamp}&end_timestamp=${end_timestamp}`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
